import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-df77f5a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-form" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "Melde dich jetzt an", -1))
const _hoisted_5 = { style: {"width":"75%","margin":"0 auto"} }
const _hoisted_6 = { class: "input-group mb-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi-person-badge-fill" })
], -1))
const _hoisted_8 = { class: "input-group mb-3" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi-envelope-heart" })
], -1))
const _hoisted_10 = { class: "input-group mb-3" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi-lock-fill" })
], -1))
const _hoisted_12 = { class: "input-group mb-3" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi-lock-fill" })
], -1))
const _hoisted_14 = {
  key: 0,
  class: "input-group mb-3",
  style: {"display":"flex","align-items":"center","justify-content":"center","color":"#dc3545"}
}
const _hoisted_15 = {
  class: "mb-3",
  style: {"display":"flex","align-items":"center","justify-content":"center"}
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mb-3",
  style: {"text-align":"center"}
}, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "secondary-link",
    href: "/"
  }, "Abbrechen und zur Startseite")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toast = _resolveComponent("Toast")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["form-control", {'is-invalid': _ctx.newUser.error && _ctx.newUser.username === ''}]),
                placeholder: "Benutzername",
                "aria-label": "Benutzername",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newUser.username) = $event))
              }, null, 2), [
                [_vModelText, _ctx.newUser.username]
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _withDirectives(_createElementVNode("input", {
                type: "email",
                class: _normalizeClass(["form-control", {'is-invalid': _ctx.newUser.error && _ctx.newUser.email === ''}]),
                placeholder: "E-Mail",
                "aria-label": "E-Mail",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newUser.email) = $event)),
                required: ""
              }, null, 2), [
                [_vModelText, _ctx.newUser.email]
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _withDirectives(_createElementVNode("input", {
                type: "password",
                class: _normalizeClass(["form-control", {'is-invalid': _ctx.newUser.error && _ctx.newUser.password === ''}]),
                placeholder: "Passwort - min. 6 Zeichen",
                "aria-label": "Passwort",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newUser.password) = $event)),
                required: ""
              }, null, 2), [
                [_vModelText, _ctx.newUser.password]
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _withDirectives(_createElementVNode("input", {
                type: "password",
                class: _normalizeClass(["form-control", {'is-invalid': _ctx.newUser.error && _ctx.newUser.password !== _ctx.passwordRepeat}]),
                placeholder: "Passwort wiederholen",
                "aria-label": "Passwort wiederholen",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.passwordRepeat) = $event)),
                required: ""
              }, null, 2), [
                [_vModelText, _ctx.passwordRepeat]
              ])
            ]),
            (_ctx.newUser.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.newUser.errorMsg), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary btn-lg",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.registerUser && _ctx.registerUser(...args))),
                style: {"width":"100%"}
              }, " Jetzt Anmelden ")
            ]),
            _hoisted_16
          ])
        ])
      ])
    ]),
    _createVNode(_component_Toast, {
      modelValue: _ctx.showToast,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showToast) = $event)),
      type: _ctx.toastType,
      message: _ctx.toastMessage
    }, null, 8, ["modelValue", "type", "message"])
  ], 64))
}